import { CSSProperties, memo, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { NewFieldStyles, NewFieldTypes, NewInputHandles, ReportTemplate } from "../../Definitions";
import { colors, fonts } from "../../Styles";
import { CheckBox, CheckStyles, NewInput, TooltipString } from "../BaseComponents";

interface ReportTemplateBar_Props {
  template?: ReportTemplate;
  onCheck?: () => void | undefined;
  onChange?: (template: ReportTemplate) => void | undefined;
  borderRadius?: CSSProperties;
  headerBar?: boolean;
  deleteable?: boolean;
  isChecked?: boolean;
  deletable?: boolean;
  editable?: boolean
}

function REPORT_TEMPLATE_BAR({ template, onCheck, borderRadius, headerBar=false, deletable=false, isChecked=false, onChange, editable }: ReportTemplateBar_Props) {
  const { t } = useTranslation();

  const toLabel: Record<number, string> = {
    0: "",
    1: t("reportPages.reportColumn.animal_number", {defaultValue: "Dyrenr."}),
    2: t("reportPages.reportColumn.group_name", {defaultValue: "Group Name"}),
    3: t("reportPages.reportColumn.system_name", {defaultValue: "System Name"}),
  };
  
  const templateNameRef = useRef<NewInputHandles>(null);

  // Columns
  const columns = useMemo(() => [
    {
      key: "templateNameRef", content: headerBar
        ? t("reportPages.reports.templateName", {defaultValue: "template name"})
        : editable
          ? <NewInput
          onChange={(e) => {}}
            ref={templateNameRef}
            onBlur={() => {if (template && onChange && templateNameRef.current !== null && typeof templateNameRef.current.value === "string" && template.name !== templateNameRef.current.value) {onChange({...template, name: templateNameRef.current?.value})}}}
              valueOverrides={{
                defaultValue: template?.name,
                valueType: "string"    
              }}
              fieldOverrides={{
                fieldStyle: NewFieldStyles.greyTertiary, 
                fieldType: NewFieldTypes.tertiaryField, 
                fieldWidth: "100%",
              }}
            />
          : template?.name,
    },
    {
      key: "templateDataLevel", content: headerBar
        ? t("reportPages.reports.dataLevel", { defaultValue: "Data Level" })
        : toLabel[template?.dataLevel ?? 0]
    },
    {
      key: "filterParams", content: headerBar
        ? t("reportPages.reports.filterParameter", { defaultValue: "Filter Parameter" })
        : (template?.filterParameter?.flatMap(param => param.map(p => t(`reportPages.reportColumn.${p.key}`))) ?? []).join(", ")
    }
  ], [headerBar, t, editable, template, onChange]);

  if (!template && !headerBar) return null;

  return (
    <div style={{ height: "35px", width: "650px", boxSizing: "border-box", zIndex: "99999", position: "relative" }}>
      <div style={{
        width: "100%",
        height: "100%",
        textAlign: "center",
        alignContent: "center",
        padding: "0px 20px",
        boxSizing: "border-box",
        backgroundColor: colors.greyLightSecondary,
        transition: "filter 0.3s",
        color: colors.greyDarkPrimary,
        ...fonts.paragraph,
        ...fonts.fontSize4,
        ...borderRadius,
        zIndex: "99999",
        position: "relative",
      }}>
        <div style={{ display: "grid", boxSizing: "border-box", height: "35px", gridTemplateColumns: "22px 206px 105px 235px 22px", textAlign: "start", alignItems: "center", gap: "5px" }}>
          {deletable ? <CheckBox checkStyle={CheckStyles.transparent} isChecked={isChecked} onChange={onCheck}/> : <span/>}
          {columns.map((col) => {
            const paddingStyle: CSSProperties = col.key === "templateNameRef" && !editable ? { paddingLeft: "5px" } : {};

            return headerBar ? (
              <TooltipString
                key={col.key}
                duplicatedStrings
                contentString={String(col.content)}
                overrides={{contentstring: {...paddingStyle}}}
              />
            ) : (
              <p key={col.key} style={{ ...fonts.fontSize4, ...fonts.paragraph, color: colors.greyDarkPrimary, ...paddingStyle }}>
                {col.content}
              </p>
            )
          })}
          <span></span>
        </div>
      </div>
    </div>
  );
}

export default memo(REPORT_TEMPLATE_BAR);